import { CloseButton, Drawer, Portal } from '@chakra-ui/react'
import type { FC, ReactNode } from 'react'
import { memo } from 'react'

import AccountRail from '@app/shared/layout/shells/components/accountRail'

interface Props {
  children: ReactNode
}

const CustomerDrawer: FC<Props> = ({ children }) => (
  <Drawer.Root placement="start">
    <Drawer.Trigger asChild>{children}</Drawer.Trigger>
    <Portal>
      <Drawer.Backdrop />
      <Drawer.Positioner padding={4}>
        <Drawer.Content rounded="md">
          <Drawer.Header>
            <Drawer.Title>Customer accounts</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body p={0}>
            <AccountRail />
          </Drawer.Body>
          <Drawer.CloseTrigger asChild>
            <CloseButton size="sm" />
          </Drawer.CloseTrigger>
        </Drawer.Content>
      </Drawer.Positioner>
    </Portal>
  </Drawer.Root>
)

export default memo(CustomerDrawer)
